import { AbstractControl, ValidatorFn } from "@angular/forms";
import * as moment from "moment";

export function isSameOrAfterValidator(otherControl: AbstractControl): ValidatorFn {
  return (control: AbstractControl): { [key: string]: any } | null => {
    const controlDate = typeof control.value === "string" ? moment(control.value) : (control.value as moment.Moment);
    const otherControlDate =
      typeof otherControl.value === "string" ? moment(otherControl.value) : (otherControl.value as moment.Moment);

    if (!controlDate?.isValid() || !otherControlDate?.isValid()) {
      return null;
    }

    const formGroup = control.parent.controls;
    const controlName = Object.keys(formGroup).find((name) => formGroup[name] === control);
    const otherControlName = Object.keys(formGroup).find((name) => formGroup[name] === otherControl);

    return controlDate.isSameOrAfter(otherControlDate)
      ? null
      : { invalidDate: `${controlName} must be greater than or equal to ${otherControlName} ` };
  };
}
